import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

// Section 01 · Data Utama — tanggal, distrik, plant, tipe pengiriman,
// slot antrian. Slot conflict warning is inline so parent doesn't need to
// juggle another prop.
export default function DataUtamaSection({
  form, setF, districts, plants, slotOptions, slotConflict,
}) {
  return (
    <div className="border border-border p-6 bg-card">
      <div className="overline mb-4">01 · Data Utama</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label className="overline block mb-2">Tanggal *</Label>
          <Input
            type="date"
            value={form.tanggal}
            onChange={(e) => setF({ tanggal: e.target.value })}
            className="rounded-lg h-11"
            data-testid="input-tanggal"
            required
          />
        </div>
        <div>
          <Label className="overline block mb-2">Distrik *</Label>
          <Select value={form.distrik_id} onValueChange={(v) => setF({ distrik_id: v })}>
            <SelectTrigger className="rounded-lg h-11" data-testid="select-distrik">
              <SelectValue placeholder="Pilih distrik" />
            </SelectTrigger>
            <SelectContent>
              {districts.map((d) => (
                <SelectItem key={d.id} value={d.id}>
                  {d.kode} ({d.nama})
                </SelectItem>
              ))}
              {districts.length === 0 && <div className="p-3 text-sm text-muted-foreground">Belum ada distrik. Tambah di menu Master Distrik.</div>}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="overline block mb-2">Plant</Label>
          <Select
            value={form.plant_id}
            onValueChange={(v) => {
              const p = plants.find((x) => x.id === v);
              setF({ plant_id: v, plant: p ? p.nama : "" });
            }}
          >
            <SelectTrigger className="rounded-lg h-11" data-testid="select-plant">
              <SelectValue placeholder="Pilih plant" />
            </SelectTrigger>
            <SelectContent>
              {plants.map((p) => (
                <SelectItem key={p.id} value={p.id}>
                  {p.kode} · {p.nama}
                </SelectItem>
              ))}
              {plants.length === 0 && <div className="p-3 text-sm text-muted-foreground">Belum ada plant. Tambah di menu Master Plant.</div>}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="overline block mb-2">Tipe Pengiriman</Label>
          <Select
            value={form.tipe_pengiriman || "__empty__"}
            onValueChange={(v) => setF({ tipe_pengiriman: v === "__empty__" ? "" : v })}
          >
            <SelectTrigger className="rounded-lg h-11" data-testid="input-tipe">
              <SelectValue placeholder="Pilih tipe pengiriman" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="__empty__">— (kosongkan) —</SelectItem>
              <SelectItem value="FOT">FOT</SelectItem>
              <SelectItem value="FRANCO">FRANCO</SelectItem>
              <SelectItem value="FOB">FOB</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="overline block mb-2">Slot Antrian (opsional)</Label>
          <Select
            value={form.slot_antrian || "__empty__"}
            onValueChange={(v) => setF({ slot_antrian: v === "__empty__" ? "" : v })}
          >
            <SelectTrigger className="rounded-lg h-11 font-mono" data-testid="input-slot-antrian">
              <SelectValue placeholder="Pilih jam antrian" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="__empty__">— (kosongkan) —</SelectItem>
              {slotOptions.map((s) => (
                <SelectItem key={s} value={s} className="font-mono">{s}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          {form.slot_antrian && slotConflict > 0 && (
            <div
              className="mt-2 text-xs bg-amber-50 border-l-4 border-amber-500 text-amber-800 px-3 py-2"
              data-testid="slot-conflict-warning"
            >
              ⚠ Sudah ada <span className="font-bold">{slotConflict}</span> SPB di slot {form.slot_antrian} pada tanggal {form.tanggal}. Bisa tetap disimpan.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
